<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="text-center">
        <h1>Loyality Rewards</h1>
      </v-col>
    </v-row>

    <user-stats-bar
      :username="$store.state.username"
      :xp-name="settings.name ?? 'Punkte'"
      :xp-value="$store.state.loyaltypoints ?? 0"
    />
    <v-row class="mb-4" dense v-if="!$store.state.logged_in">
      <v-col cols="12" class="pt-2">
        <v-btn tile color="#9147ff" class="text--white" :href="loginUrl" :block="$vuetify.breakpoint.smAndDown">
          <v-icon left>mdi-twitch</v-icon>
          Login mit Twitch
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col v-for="(reward, index) in rewards" :key="index" cols="12" sm="6" md="4">
        <v-card class="d-flex flex-column" elevation="2" height="100%">

          <!-- Mobile: Titel + kleines Thumbnail nebeneinander -->
          <template v-if="$vuetify.breakpoint.smAndDown">
            <div class="d-flex align-center pa-3 pb-1">
              <div class="flex-grow-1 mr-2">
                <div class="subtitle-1 font-weight-bold">{{ reward.title }}</div>
                <v-chip x-small color="primary" outlined class="mt-1">{{ reward.cost }} Punkte</v-chip>
              </div>
              <v-img
                v-if="getItemImage(reward.img)"
                :src="getItemImage(reward.img)"
                width="56"
                height="56"
                contain
                class="flex-shrink-0 rounded"
              />
            </div>
          </template>

          <!-- Desktop: Bild rechts neben Titel -->
          <template v-else>
            <div class="d-flex justify-space-between align-center pa-2">
              <div class="flex-grow-1">
                <v-card-title class="text-h6">{{ reward.title }}</v-card-title>
                <v-card-subtitle>Reward Kosten: {{ reward.cost }}</v-card-subtitle>
              </div>
              <v-img :src="getItemImage(reward.img)" max-width="100" max-height="100" class="ml-3" contain />
            </div>
          </template>

          <v-card-text>{{ reward.prompt }}</v-card-text>

          <v-card-text
            v-if="reward.max_per_stream_is_enabled || reward.max_per_user_per_stream_is_enabled"
            class="pt-0"
          >
            <v-row dense>
              <v-col cols="12" sm="6" v-if="reward.max_per_stream_is_enabled">
                <strong>Einlösungen:</strong>
                {{ `${reward.redeemed_stream} / ${reward.max_per_stream || 0}` }}
              </v-col>
              <v-col cols="12" sm="6" v-if="reward.max_per_user_per_stream_is_enabled">
                <strong>Benutzer Einlösungen:</strong>
                {{ `${reward.redeemed_user} / ${reward.max_per_user_per_stream || 0}` }}
              </v-col>
            </v-row>
          </v-card-text>

          <v-spacer />

          <v-card-actions class="pa-3">
            <v-btn
              color="primary"
              @click="redeemReward(index)"
              :block="$vuetify.breakpoint.smAndDown"
              :disabled="reward.is_paused === 1 ||
                (reward.redeemed_user >= reward.max_per_user_per_stream &&
                  reward.max_per_user_per_stream_is_enabled === 1) ||
                (reward.redeemed_stream >= reward.max_per_stream &&
                  reward.max_per_stream_is_enabled === 1) ||
                waiting === 1"
            >
              Einlösen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="showInputDialog" max-width="400">
      <v-card>
        <v-card-title>Eingabe erforderlich</v-card-title>
        <v-card-text>
          <v-text-field v-model="userInput" label="Gib deine Eingabe ein"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="cancelInput">Abbrechen</v-btn>
          <v-btn @click="confirmInput()">Bestätigen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="errorReedemReward" timeout="5000" color="red">
      {{ dynamicErrorMsg }}
      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="errorReedemReward = false">Close</v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="ReedemReward" timeout="3000" color="green">
      {{ dynamicReedemMsg }}
      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="ReedemReward = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>

import BackendService from '@/services/BackendService';
import UserStatsBar from '@/components/UserStatsBar.vue';

export default {
  name: 'LoayltiyRewardsView',
  components: {
    UserStatsBar,
  },

  data: () => ({
    sendData: {},
    settings: [],
    intervalId: null,
    rewards_raw: [],
    userInput: '',
    showInputDialog: false,
    currentIndex: null,
    selectReward: null,
    errorReedemReward: false,
    dynamicErrorMsg: '',
    ReedemReward: false,
    dynamicReedemMsg: '',
    currentReedemRewards: [],
    redeemCounts: {},
    waiting: 0,
    socket: null,
    heartbeatInterval: null,
    reconnectTimeout: null,
    suppressReconnect: false,
    sessionId: {
      type: String,
      required: true,
    },
  }),
  mounted() {
    function getSessionIdFromUrl() {
      const parts = window.location.pathname.split('/');
      return parts.pop() || parts.pop();
    }

    this.sessionId.value = getSessionIdFromUrl();
    this.loadInstance(this.$route.params.id);
  },
  beforeRouteUpdate(to, from, next) {
    this.loadInstance(to.params.id);
    next();
  },
  computed: {
    rewards() {
      return this.rewards_raw
        .filter((reward) => reward.is_enabled === 1)
        .sort((a, b) => a.cost - b.cost || String(a.cp_id).localeCompare(String(b.cp_id)));
    },
  },
  destroyed() {
    clearInterval(this.intervalId);
    this.teardownSocket();
  },
  methods: {
    loadInstance(id) {
      // Tear down the previous instance's connection first so its pushed updates
      // (and the HTTP session db it resolved) can never leak into the new instance.
      this.teardownSocket();
      this.rewards_raw = [];
      this.sendData = { id };
      BackendService.loadRewardsPublic(this.sendData).finally(() => {
        this.$store.dispatch('refreshStatus');
      });
      this.connectSocket();
    },
    teardownSocket() {
      this.suppressReconnect = true;
      clearTimeout(this.reconnectTimeout);
      this.reconnectTimeout = null;
      clearInterval(this.heartbeatInterval);
      this.heartbeatInterval = null;
      if (this.socket) {
        this.socket.close();
        this.socket = null;
      }
    },
    stopHeartbeat() {
      if (this.heartbeatInterval) {
        clearInterval(this.heartbeatInterval);
        this.heartbeatInterval = null;
      }
    },
    startHeartbeat() {
      this.stopHeartbeat();
      this.heartbeatInterval = setInterval(() => {
        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
          this.socket.send('ping'); // Client sendet Ping
        }
      }, 10000); // alle 10s
    },
    scheduleReconnect() {
      if (this.reconnectTimeout) return; // nur einmal gleichzeitig
      this.reconnectTimeout = setTimeout(() => {
        this.reconnectTimeout = null;
        console.log('🔄 Reconnect...');
        this.connectSocket();
      }, 2000);
    },
    connectSocket() {
      this.suppressReconnect = false;
      this.socket = new WebSocket(
        `${process.env.VUE_APP_WS_PROTOCOL}://${process.env.VUE_APP_WS_URL}`,
        // `${process.env.VUE_APP_WS_PROTOCOL}://${process.env.VUE_APP_WS_URL}:${process.env.VUE_APP_WS_PORT}`,
      );

      this.socket.addEventListener('open', () => {
        console.log('✅ WebSocket verbunden');
        this.startHeartbeat(); // Starte Client-Pings
      });

      this.socket.addEventListener('message', (event) => {
        // Server-Pong (neues Heartbeat-System)
        if (event.data === 'pong') {
          return; // Verbindung lebt
        }

        let command = null;
        try {
          command = JSON.parse(event.data);
        } catch (err) {
          console.warn('⚠️ Ungültige Nachricht:', event.data);
          return;
        }

        let newData = null;
        switch (command.cmd) {
          case 'init':
            this.socket.send(
              JSON.stringify({
                cmd: 'init',
                id: this.$route.params.id,
                clientType: 'trigger',
              }),
            );
            break;
          case 'initdata':
            this.settings = command.data.settings;
            this.rewards_raw = command.data.rewards;
            break;
          case 'update':
            newData = this.rewards_raw.map(
              (item) => (item.cp_id === command.data.cp_id ? command.data : item),
            );
            if (!newData.some((item) => item.cp_id === command.data.cp_id)) {
              newData.push(command.data);
            }
            this.rewards_raw = newData;
            break;
          case 'add':
            this.rewards_raw.push(command.data);
            break;
          case 'delete':
            this.rewards_raw = this.rewards_raw.filter((item) => item.cp_id !== command.data);
            break;
          case 'redeem':
            newData = this.rewards_raw.map(
              (item) => (item.cp_id === command.data.cp_id ? command.data : item),
            );
            if (!newData.some((item) => item.cp_id === command.data.cp_id)) {
              newData.push(command.data);
            }
            this.rewards_raw = newData;
            break;
          default:
            console.log('unknown cmd: ', event.data);
            break;
        }
      });

      this.socket.addEventListener('error', (err) => {
        console.error('❌ WebSocket Fehler:', err);
        this.socket.close();
      });

      this.socket.addEventListener('close', () => {
        console.log('⚠️ Verbindung verloren');
        this.stopHeartbeat();
        if (!this.suppressReconnect) {
          this.scheduleReconnect();
        }
      });
    },
    getItemImage(path) {
      if (path === null || path === '') {
        return '';
      }
      return `${process.env.VUE_APP_BACKENDSERVICE_BASEURL}img/${path}`;
    },
    updateTimer() {
      BackendService.loadRewardsPublic(this.sendData).then((data) => {
        // console.log(data.data);
        this.rewards = data.data.rewards
          .filter((reward) => reward.is_enabled === 1)
          .sort((a, b) => a.cost - b.cost);
        this.currentReedemRewards = data.data.reedem_reward;
        this.settings = data.data.settings;
      });
    },
    redeemReward(index) {
      const reward = this.rewards[index];
      if (reward.is_user_input_required === 1) {
        // Öffne den Dialog für die Benutzereingabe
        this.showInputDialog = true;
        this.selectReward = this.rewards[index];
        // console.log(this.rewards[index]);
      } else {
        // Führe die normale Einlöselogik durch
        this.performRedeem(reward);
      }
    },
    cancelInput() {
      // Schließe den Dialog und setze das Eingabefeld zurück
      this.showInputDialog = false;
      this.userInput = '';
    },
    confirmInput() {
      // Führe die Einlöselogik mit der Benutzereingabe durch
      const userInput = this.userInput.trim();
      if (userInput !== '') {
        // Hier könntest du die Benutzereingabe verwenden, z.B. mit einer API-Anfrage
        // console.log('Benutzereingabe:', userInput);

        // Führe die normale Einlöselogik durch
        this.performRedeem(this.selectReward, userInput);

        // Schließe den Dialog und setze das Eingabefeld zurück
        this.showInputDialog = false;
        this.userInput = '';
      } else {
        // Benutzereingabe ist erforderlich, aber leer
        // Hier könntest du eine Benachrichtigung für den Benutzer hinzufügen
        // console.error('Benutzereingabe ist erforderlich, aber leer.');
      }
    },
    performRedeem(reward, userinput) {
      this.waiting = 1;
      this.sendData = {};
      this.sendData.reward = reward;
      this.sendData.userinput = userinput;
      this.sendData.userpoints = this.$store.state.loyaltypoints;
      this.sendData.room = this.$router.currentRoute.params.id;

      // console.log(reward);
      // console.log(userinput);
      // console.log('Belohnung einlösen:', reward);
      BackendService.redeemRewardsPublic(this.sendData).then((data) => {
        console.log(data.data);
        this.$store.commit('set_loyaltypoints', data.data.points);
        this.rewards = data.data.rewards
          .sort((a, b) => a.cost - b.cost);
        this.dynamicReedemMsg = 'Reward erfolgreich eingelöst!';
        this.ReedemReward = true;
        this.waiting = 0;
      }).catch((error) => {
        // console.log(error.response.status);
        // console.log(error.response.data);
        if (error.response.status === 409 && error.response.data === 'not_enough_points') {
          this.dynamicErrorMsg = 'Nicht genügen Points für den Reward!';
          this.errorReedemReward = true;
        } else if (error.response.status === 409 && error.response.data === 'global_cooldown_activ') {
          this.dynamicErrorMsg = 'Dieser Reward ist noch im Cooldown!';
          this.errorReedemReward = true;
        } else if (error.response.status === 409 && error.response.data === 'not_enough_slots') {
          this.dynamicErrorMsg = 'In diesem Stream steht dieser Reward leider nicht mehr zur Verfügung!';
          this.errorReedemReward = true;
        } else if (error.response.status === 409 && error.response.data === 'not_enough_slots_for_user') {
          this.dynamicErrorMsg = 'Du hast bereits die maximalen Einlösungen für diesen Reward in diesem Stream erreicht!';
          this.errorReedemReward = true;
        } else if (error.response.status === 409 && error.response.data === 'sraborted') {
          this.dynamicErrorMsg = 'Leider wurde dein Songrequest abgelehnt! Dir wurden keine Punkte abgezogen!';
          this.errorReedemReward = true;
        }
        this.waiting = 0;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.giveaway {
  &_header {
    background-color: darkblue;
    color: white;
    text-align: center;
    width: 50vw;
    margin: 10px auto 0 auto;
  }

  &_body {
    text-align: center;
    width: 50vw;
    margin: 10px auto 0 auto;
  }
}

.card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.card-actions {
  margin-top: auto;
  /* Setzt die Margin für den oberen Bereich auf "auto" */
}

.v-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: box-shadow 0.3s ease;
}
</style>
